import { Routes } from './routes';

export const Navigation = () => <Routes />;
